import React from 'react';
import moment from 'moment';
import { Link } from 'react-router-dom';
import { ThomasCampaign } from 'models/interfaces';

interface PvsVerticalCampaignListProps {
  campaigns: ThomasCampaign[];
}

const PvsVerticalCampaignList: React.FunctionComponent<PvsVerticalCampaignListProps> = ({
  campaigns
}) => {
  const rows = campaigns.map((x: ThomasCampaign) => {
    const startDate = moment(new Date(x.start_date)).format('MM-DD-YYYY');
    const endDate = moment(new Date(x.end_date)).format('MM-DD-YYYY');

    return (
      <tr key={x.campaign_id}>
        <td>
          <Link to={`/advertisers/${x.tgrams_id}/campaigns/${x.campaign_id}/edit`}>{x.name}</Link>
        </td>
        <td className="align-right">{startDate}</td>
        <td className="align-right">{endDate}</td>
        <td>
          {' '}
          <Link to={`/advertisers/${x.tgrams_id}/campaigns/${x.campaign_id}/edit`}>Edit</Link>
        </td>
      </tr>
    );
  });

  return (
    <table className="table inventory__campaigns-table hover">
      <thead>
        <tr>
          <th>Name</th>
          <th className="align-right">Start Date</th>
          <th className="align-right">End Date</th>
          <th>Edit</th>
        </tr>
      </thead>
      <tbody>{rows}</tbody>
    </table>
  );
};

export default PvsVerticalCampaignList;
